import {Component, Input, OnInit, AfterViewInit, Output, OnDestroy} from '@angular/core';
import {ServiceService} from "../../services/service.service";



import {PagerDataObject} from "../../entities/pagerDataObject";

import {Service} from "../../entities/service";
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SharedService } from 'src/app/services/sharedService';

@Component({
    selector: 'app-service-list',
    templateUrl: './service-list.component.html',
    styleUrls: ['./service-list.component.css'],
    standalone: false
})
export class ServiceListComponent implements OnInit {

 
  metaInfo: string[];
  columns: Array<any>;
  data: PagerDataObject;
  @Input()
  headers = [' ', 'Name', 'Code'];
  @Input()
  disableHeader = false;
  subscription: any;
  private dataSub$ = new Subject<any>();
  query: String;

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.sharedService.loadMenuItems('admin');
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  constructor(private serviceService: ServiceService, private sharedService: SharedService) {
    this.subscription = this.dataSub$.pipe(switchMap(filter => {
      return this.serviceService.getData(filter);
    }))
      .subscribe(data => {
        if (data && data.records) {
          data.records = data.records.map(s => ({
            ...s,
            published: {
              label: s.isForPortal ? 'PUBLISHED' : 'NOT PUBLISHED',
              extra: null
            }
          }));
        }
        this.data = data;
      });
    this.metaInfo = this.serviceService.getMetaInfo();
    this.columns = this.serviceService.getColumns();
  }

  onGridQuery(query) {
    this.query = query
    this.dataSub$.next(query);
  }

  deleteService(entity){
    let service = new Service();
    service.id = entity;
    this.serviceService.delete(service)
      .subscribe(service => {
        this.dataSub$.next(this.query);
      });
  }

}
